import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import ReactCodeInput from 'react-verification-code-input'

import { cn } from '@repo/utils'

import styles from './index.css'

class VerificationCodeInput extends PureComponent {
  render() {
    const { ariaLabel, className, onChange, onComplete, placeholder, value, ...props } = this.props

    return (
      <div className={cn(styles.wrapper, className)}>
        <ReactCodeInput
          fieldHeight={40}
          fieldWidth={40}
          onChange={onChange}
          onComplete={onComplete}
          placeholder={placeholder.split('')}
          title={ariaLabel}
          type="number"
          values={value.split('')}
          {...props}
        />
      </div>
    )
  }
}

VerificationCodeInput.propTypes = {
  ariaLabel: PropTypes.string,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fields: PropTypes.number,
  onChange: PropTypes.func,
  onComplete: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
}

VerificationCodeInput.defaultProps = {
  ariaLabel: '',
  autoFocus: false,
  className: '',
  disabled: false,
  fields: 6,
  onChange: Function.prototype,
  onComplete: Function.prototype,
  placeholder: '',
  value: '',
}

export default VerificationCodeInput
